import React from 'react';
import { Navbar as BootstrapNavbar, Nav, Container } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { PersonCircle, BoxArrowRight } from 'react-bootstrap-icons';
import { useAuth } from '../../context/AuthContext';

const Navbar = () => {
    const location = useLocation();
    const { isAuthenticated, admin, logout } = useAuth();

    const handleLogout = () => {
        logout();
        window.location.href = '/login';
    };

    return (
        <BootstrapNavbar 
            bg="primary" 
            variant="dark" 
            expand="lg" 
            sticky="top" 
            className="shadow-sm"
        >
            <Container fluid>
                {/* Brand */}
                <BootstrapNavbar.Brand 
                    as={Link} 
                    to="/" 
                    className="fw-bold d-flex align-items-center"
                >
                    <i className="bi bi-calendar-check me-2 fs-4"></i>
                    Interview Scheduler
                </BootstrapNavbar.Brand>

                {/* Mobile Toggle */}
                <BootstrapNavbar.Toggle aria-controls="navbar-nav" className="border-0" />
                <BootstrapNavbar.Collapse id="navbar-nav">
                    <Nav className="ms-auto align-items-center gap-2">
                        {isAuthenticated && admin ? (
                            <>
                                {/* Username badge */}
                                <span className="badge bg-light text-primary d-flex align-items-center px-3 py-2 rounded-pill">
                                    <PersonCircle className="me-1" size={18} />
                                    {admin.firstName}
                                </span>

                                {/* Logout button */}
                                <button
                                    onClick={handleLogout}
                                    className="btn btn-danger btn-sm rounded-pill d-flex align-items-center px-3"
                                >
                                    <BoxArrowRight className="me-1" size={16} />
                                    Logout
                                </button>
                            </>
                        ) : (
                            <Nav.Link 
                                as={Link} 
                                to="/login" 
                                className="fw-semibold btn btn-light px-3 rounded-pill"
                            >
                                Login
                            </Nav.Link>
                        )}
                    </Nav>
                </BootstrapNavbar.Collapse>
            </Container>
        </BootstrapNavbar>
    );
};

export default Navbar;
